import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickHome = () => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_HOME',
      analytics: {
        SCREEN: 'GOODS_DETAIL',
      },
    });
  }, []);
};
